
import { defineComponent, ref, computed } from 'vue'
import AppCheckbox from '@/components/atoms/AppCheckbox.vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import toLocale from '@/helpers/util/toLocale'
import NdcDivisions from '@/data/master/NdcDivisions'
import { getLabelWithCode } from '@/data/master/MasterUtil'

export default defineComponent({
  name: 'FacetPanelRecursiveList',
  components: {
    AppCheckbox,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    n: {
      type: Number,
      default: 1,
    },
    name: {
      type: String,
      required: true,
    },
    checkedFacet: {
      type: Array,
      required: true,
    },
    search: {
      type: Function,
      required: false,
    },
  },
  setup (props) {
    const store = useStore()
    const lang = useI18n().locale
    const collectionMaster = computed(() => store.getters.CollectionMaster)

    const checkedFacetKeys = computed(() => props.checkedFacet)
    return {
      selected: ref(false),
      getFacetLabel: (key: string) => {
        switch (props.name) {
          case 'digitizedContents':
          case 'onlinePublications':
          case 'materialTypeLabel':
            return collectionMaster.value[key] ? collectionMaster.value[key].content.name?.[lang.value] : ''
          case 'ndcDivisions':
            return getLabelWithCode(NdcDivisions, key, lang.value as 'ja' | 'en')
          default:
            return key
        }
      },
      checkedFacetKeys,
      toLocale,
    }
  },
})
